import { FC } from 'react';

import { Close, User3 } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import { UserMenuButtonWrapper } from './UserMenuButtonStyle';

export interface IUserMenuButton {
  isOpen: boolean;
  toogleMenuOpen: () => void;
}

const UserMenuButton: FC<IUserMenuButton> = ({
  isOpen = false,
  toogleMenuOpen,
}) => (
  <UserMenuButtonWrapper onClick={toogleMenuOpen}>
    <CustomIcon
      fontSize={20}
      icon={isOpen ? Close : User3}
      paletteColor='whiteAlpha600'
    />
  </UserMenuButtonWrapper>
);

export default UserMenuButton;
